module.exports = __webpack_public_path__ + "img/leiterinnen_hedije-zenelaj.43c3fe24.png";